var _rect, _circle, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _path, _rect8, _rect9, _rect10, _rect11, _rect12, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgActivitySkeleton = function SvgActivitySkeleton(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 375 93"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 373,
    height: 93,
    x: 1,
    fill: "#fff",
    rx: 3
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 46.5,
    r: 20,
    fill: "#D4D6D6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 10,
    x: 69,
    y: 13,
    fill: "#EBEDED",
    rx: 3
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 8,
    x: 105,
    y: 14,
    fill: "#EBEDED",
    rx: 3
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 110,
    height: 10,
    x: 120,
    y: 13,
    fill: "#EBEDED",
    rx: 3
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 8,
    x: 328,
    y: 14,
    fill: "#EBEDED",
    rx: 3
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 290,
    height: 10,
    x: 69,
    y: 32,
    fill: "#EBEDED",
    rx: 3
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 10,
    x: 69,
    y: 51,
    fill: "#EBEDED",
    rx: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#activity-skeleton_svg__a)",
    d: "M69 86c0-6.627 5.373-12 12-12h293v16a3 3 0 0 1-3 3H69z"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 8,
    x: 213,
    y: 79,
    fill: "#D4D6D6",
    rx: 3
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 8,
    x: 245,
    y: 79,
    fill: "#D4D6D6",
    rx: 3
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 8,
    x: 277,
    y: 79,
    fill: "#D4D6D6",
    rx: 3
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 8,
    x: 309,
    y: 79,
    fill: "#D4D6D6",
    rx: 3
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 8,
    x: 341,
    y: 79,
    fill: "#D4D6D6",
    rx: 3
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "activity-skeleton_svg__a",
    x1: 221.5,
    x2: 221.5,
    y1: 74,
    y2: 93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F5",
    stopOpacity: 0
  })))));
};
export default SvgActivitySkeleton;